/* NC Polsterung – Interaktionen (ncneder) */
(function () {
  if (window.__ncPol) return; window.__ncPol = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = 'IntersectionObserver' in window;
  function $$(s, r) { return [].slice.call((r || document).querySelectorAll(s)); }
  function play(v) { if (!v) return; v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); }

  function init() {
    /* Reveal */
    var rv = $$('[data-pol-rv],[data-pol-clip]');
    if (!io || reduce) rv.forEach(function (e) { e.classList.add('is-in'); });
    else {
      var o = new IntersectionObserver(function (en) { en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); o.unobserve(e.target); } }); }, { threshold: .12, rootMargin: '0px 0px -6% 0px' });
      rv.forEach(function (e) { o.observe(e); });
    }

    /* Videos nur im Sichtbereich abspielen */
    var vids = $$('video.pol-lazy');
    vids.forEach(function (v) { v.muted = true; v.setAttribute('muted', ''); v.playsInline = true; v.loop = true; });
    if (!reduce) {
      if (io) {
        var vo = new IntersectionObserver(function (en) {
          en.forEach(function (e) {
            var v = e.target;
            if (v.hasAttribute('data-pol-keep')) return;
            if (e.isIntersecting) { if (v.preload === 'none') v.preload = 'auto'; play(v); }
            else if (!v.paused) v.pause();
          });
        }, { threshold: .15 });
        vids.forEach(function (v) { vo.observe(v); });
      } else vids.forEach(play);
    }

    /* Hero */
    var hero = document.querySelector('[data-pol-hero]');
    if (hero) {
      var m = window.matchMedia('(max-width: 699px)').matches;
      $$(m ? '.pol-hero__v--d' : '.pol-hero__v--m', hero).forEach(function (x) { x.remove(); });
      var hv = hero.querySelector('video'); if (hv && !reduce) { hv.preload = 'auto'; play(hv); }
      if (!reduce) {
        var tick = false;
        window.addEventListener('scroll', function () {
          if (tick) return; tick = true;
          requestAnimationFrame(function () { tick = false; var p = Math.min(1, Math.max(0, window.scrollY / (hero.offsetHeight || 1))); hero.style.setProperty('--hp', p.toFixed(3)); });
        }, { passive: true });
      }
    }

    /* Mobil: feste Anfrage-Leiste */
    var form = document.getElementById('anfrage');
    if (hero && form) {
      var css = document.createElement('style');
      css.textContent =
        '.pol-sticky{position:fixed;left:0;right:0;bottom:0;z-index:45;display:none;align-items:center;gap:14px;padding:10px 16px calc(10px + env(safe-area-inset-bottom));background:rgba(255,255,255,.96);-webkit-backdrop-filter:blur(12px);backdrop-filter:blur(12px);border-top:1px solid rgba(29,26,23,.12);box-shadow:0 -18px 40px -30px rgba(29,26,23,.35);transform:translateY(110%);transition:transform .45s cubic-bezier(.2,.8,.2,1);font-family:var(--text-font-family);color:#1d1a17}' +
        '@media (max-width:699px){.pol-sticky{display:flex}}' +
        '.pol-sticky.is-on{transform:none}' +
        '.pol-sticky__txt{flex:1;min-width:0;line-height:1.25}' +
        '.pol-sticky__txt strong{display:block;font-family:var(--heading-font-family);font-weight:300;font-size:1.05rem;letter-spacing:-.01em;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
        '.pol-sticky__txt span{display:block;font-size:.62rem;letter-spacing:.2em;text-transform:uppercase;color:#7a7169;margin-top:2px}' +
        '.pol-sticky__btn{flex:none;display:inline-flex;align-items:center;gap:10px;background:#1d1a17;color:#fff;text-decoration:none;font-size:.66rem;font-weight:500;letter-spacing:.16em;text-transform:uppercase;padding:15px 18px}';
      document.head.appendChild(css);
      var bar = document.createElement('div');
      bar.className = 'pol-sticky'; bar.setAttribute('aria-hidden', 'true');
      bar.innerHTML = '<div class="pol-sticky__txt"><strong>' + (hero.getAttribute('data-sticky-title') || 'Uw meubel in lamsvacht') + '</strong><span>' + (hero.getAttribute('data-sticky-sub') || 'Antwoord binnen 24 uur · vrijblijvend') + '</span></div>' +
        '<a class="pol-sticky__btn" href="#anfrage" tabindex="-1">' + (hero.getAttribute('data-sticky-label') || 'Offerte aanvragen') + ' <svg width="12" height="10" viewBox="0 0 14 10" fill="none" stroke="currentColor" aria-hidden="true"><path d="M0 5h13M9 1l4 4-4 4"/></svg></a>';
      document.body.appendChild(bar);
      var formSec = form.nextElementSibling || form, fin = document.querySelector('.pol-final'), vis = { f: false, e: false };
      function upd() {
        var past = window.scrollY > hero.offsetHeight * .7;
        var on = past && !vis.f && !vis.e;
        bar.classList.toggle('is-on', on); bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        bar.querySelector('a').tabIndex = on ? 0 : -1;
      }
      if (io) {
        new IntersectionObserver(function (en) { vis.f = en[0].isIntersecting; upd(); }, { threshold: 0, rootMargin: '0px 0px -30% 0px' }).observe(formSec);
        if (fin) new IntersectionObserver(function (en) { vis.e = en[0].isIntersecting; upd(); }, { threshold: .25 }).observe(fin);
      }
      var st = false;
      window.addEventListener('scroll', function () { if (st) return; st = true; requestAnimationFrame(function () { st = false; upd(); }); }, { passive: true });
      upd();
    }

    /* Statement: Wort für Wort */
    $$('[data-pol-st]').forEach(function (st) {
      var ws = $$('.pol-st__w, .pol-st__pill', st);
      if (reduce || !ws.length) { ws.forEach(function (w) { w.style.setProperty('--wo', 1); }); return; }
      var raf = null;
      function upd() {
        raf = null;
        var r = st.getBoundingClientRect(), vh = window.innerHeight;
        var p = Math.min(1, Math.max(0, (vh * .85 - r.top) / (r.height * .9 + vh * .15)));
        var n = ws.length, f = p * (n + 3);
        ws.forEach(function (w, i) { var o = Math.min(1, Math.max(.16, f - i)); w.style.setProperty('--wo', o.toFixed(2)); });
      }
      window.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(upd); }, { passive: true });
      window.addEventListener('resize', upd); upd();
    });

    /* Galerie-Cursor */
    $$('[data-pol-gal]').forEach(function (g) {
      if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches || reduce) return;
      var c = document.createElement('div'); c.className = 'pol-cursor'; c.textContent = g.getAttribute('data-cursor') || 'Aanvragen';
      document.body.appendChild(c); g.classList.add('has-cursor');
      g.addEventListener('mousemove', function (e) { c.style.setProperty('--cx', e.clientX + 'px'); c.style.setProperty('--cy', e.clientY + 'px'); });
      $$('.pol-tile', g).forEach(function (t) {
        t.addEventListener('mouseenter', function () { c.classList.add('is-on'); });
        t.addEventListener('mouseleave', function () { c.classList.remove('is-on'); });
      });
    });

    /* Material: Sticky-Bühne */
    $$('[data-pol-mat]').forEach(function (s) {
      var items = $$('.pol-mat__item', s), layers = $$('.pol-mat__frame > div', s), cnt = s.querySelector('[data-pol-mat-no]');
      function set(i) {
        items.forEach(function (x, k) { x.classList.toggle('is-on', k === i); });
        layers.forEach(function (x, k) { x.classList.toggle('is-on', k === i); var v = x.querySelector('video'); if (v) { if (k === i && !reduce && x.offsetParent !== null) play(v); else v.pause(); } });
        if (cnt) cnt.textContent = ('0' + (i + 1)).slice(-2) + ' / ' + ('0' + items.length).slice(-2);
      }
      set(0);
      if (!io) return;
      var mo = new IntersectionObserver(function (en) { en.forEach(function (e) { if (e.isIntersecting) set(items.indexOf(e.target)); }); }, { rootMargin: '-45% 0px -45% 0px' });
      items.forEach(function (x) { mo.observe(x); });
    });

    /* Film */
    $$('[data-pol-film]').forEach(function (f) {
      var v = f.querySelector('video'); if (!v) return;
      var btn = f.querySelector('[data-pol-film-play]'), ctl = f.querySelector('[data-pol-film-ctl]'), bar = f.querySelector('[data-pol-film-bar]');
      var lblOn = f.getAttribute('data-on') || 'Met geluid bekijken', lblOff = f.getAttribute('data-off') || 'Geluid uit';
      v.muted = true;
      function sound(on) {
        v.muted = !on; f.classList.toggle('is-sound', on);
        if (ctl) ctl.querySelector('span').textContent = on ? lblOff : lblOn;
        if (on) { v.currentTime = 0; v.setAttribute('data-pol-keep', ''); } else v.removeAttribute('data-pol-keep');
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      }
      if (btn) btn.addEventListener('click', function (e) { e.stopPropagation(); sound(true); });
      if (ctl) ctl.addEventListener('click', function (e) { e.stopPropagation(); sound(v.muted); });
      f.querySelector('.pol-film__frame').addEventListener('click', function () { sound(v.muted); });
      v.addEventListener('timeupdate', function () { if (bar && v.duration) bar.style.transform = 'scaleX(' + (v.currentTime / v.duration) + ')'; });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
